<template lang="pug">
  #signUpIndex
    .container-width.bg-black
      .px-3.py-4.customContainerBorder
        h5.text-center.font-weight-bold.mb-4 申請LINE個人化服務
        StepComponent(
          :stepArr="stepArr",
          :nowStep="nowStep"
        )
        #step1(v-if="nowStep == 1")
          .mb-4.d-flex.align-items-center
            .customBesideLine.col
            p.mb-0.customBesideCenter.text-center 本服務限曾經在 {{ $companyName }}專門店或官方帳號留存資料之顧客申請使用
            .customBesideLine.col
          .text-area-scroll.mb-2
            //.line-text-header
              .before-line
              code.title.font-weight-bold 使用須知
              .after-line
            .px-3
              .line-text-body.py-2.text-justify.text-center
                p 申請 LINE 官方帳號綁定服務時，OLENS 將根據您提供的姓名及行動電話與 LINE 帳號進行身分驗證查詢及驗證服務於 OLENS 執行，不會經由 LINE 紀錄資料。
                p 成功綁定個人化服務後，若更換手機或重新安裝 LINE APP，
                  code 需以原本 LINE ID 登入
                  | 以利後續 LINE 個人化服務使用。
            .border-bottom
            .border-bottom.mt-2
          b-form-checkbox.text-center.font-weight-bold.mb-3.mt-3(
            id="agree"
            v-model="agree_status"
            name="agree"
            :value="true"
            :unchecked-value="false"
          ) 我已詳閱並同意相關使用須知
          .px-4
            button.button.btn-block.button_clickCustom.button_clickCustom-outline-primary(
              @click="nextStepHandler()"
            )
              | 下一步
        #step2(v-if="nowStep == 2")
          .mb-4.d-flex.align-items-center
            .customBesideLine.col
            div
              p.mb-0.text-center.mx-1 請輸入以下資料以完成服務設定
                .customColor.text-center.mx-3 您所輸入的資料需與留存於OLENS系統的資料相同
            .customBesideLine.col
          .border-0.mb-2
            ValidationObserver(
              ref="mobileVerfityForm"
              tag="form"
              @submit.stop.prevent="mobileVerfityHandler"
            )
              b-form-group
                ValidationProvider(
                  rules="required",
                  ref="inputValStore",
                  v-slot="{ errors }"
                )
                  div.customInputDiv(style='background-color: #E5E5E5')
                    span.redRemind.ml-3 *
                    span.white-space-nowrap.ml-2 發卡店櫃
                    div.w-100
                      b-form-select.customInput(
                        id="birthYear",
                        required,
                        v-model="userForm.store_id",
                        :state="validState('store_id')",
                        aria-describedby="input-live-help input-name-live-feedback",
                        placeholder="",
                        style='background-color: #E5E5E5'
                      )
                        template(
                          v-slot:first
                        )
                          b-form-select-option.d-none(
                            :value="undefined",
                            disabled
                          )
                        b-form-select-option(
                          v-for="(option,index) in storeCodeOption",
                          :key="option.id",
                          :value="option.id"
                        ) {{ option.name }}
                        b-form-invalid-feedback(
                          id="input-name-live-feedback"
                        )
                          span 此欄為必填

              b-form-group
                ValidationProvider(
                  rules="required",
                  ref="inputValCardDate",
                  v-slot="{ errors }"
                )
                  div.customInputDiv(style='background-color: #E5E5E5')
                    span.redRemind.ml-3 *
                    span.white-space-nowrap.ml-2 首次發卡日
                    div.w-100
                      b-form-input.customInput(
                        id="register_date",
                        type="text",
                        required,
                        trim,
                        :state="validState('register_date')",
                        v-model="userForm.register_date",
                        aria-describedby="input-live-help input-name-live-feedback",
                        placeholder="YYYYMMDD"
                        style='background-color: #E5E5E5'
                      )
                        b-form-invalid-feedback(
                          id="input-name-live-feedback"
                        )
                          span {{ errors[0] }}
              b-form-group
                ValidationProvider(
                  rules="required",
                  ref="inputValMemberCode",
                  v-slot="{ errors }"
                )
                  div.customInputDiv(style='background-color: #E5E5E5')
                    span.redRemind.ml-3 *
                    span.white-space-nowrap.ml-2 會員代號
                    div.w-100
                      b-form-input.customInput(
                        id="member_code",
                        type="text",
                        required,
                        trim,
                        :state="validState('member_code')",
                        v-model="userForm.member_code",
                        aria-describedby="input-live-help input-name-live-feedback",
                        placeholder="會員代號"
                        style='background-color: #E5E5E5'
                      )
                        b-form-invalid-feedback(
                          id="input-name-live-feedback"
                        )
                          span {{ errors[0] }}
              b-form-group
                ValidationProvider(
                  rules="required",
                  ref="inputValEmployeeCode",
                  v-slot="{ errors }"
                )
                  div.customInputDiv(style='background-color: #E5E5E5')
                    span.redRemind.ml-3 *
                    span.white-space-nowrap.ml-2 發卡人員代號
                    div.w-100
                      b-form-input.customInput(
                        id="employee_code",
                        type="text",
                        required,
                        trim,
                        :state="validState('employee_code')",
                        v-model="userForm.employee_code",
                        aria-describedby="input-live-help input-name-live-feedback",
                        placeholder="發卡人員代號"
                        style='background-color: #E5E5E5'
                      )
                        b-form-invalid-feedback(
                          id="input-name-live-feedback"
                        )
                          span {{ errors[0] }}

              b-form-group
                ValidationProvider(
                  rules="required",
                  ref="inputValName",
                  v-slot="{ errors }"
                )
                  div.customInputDiv
                    span.redRemind.ml-3 *
                    span.white-space-nowrap.ml-2 姓名
                    div.w-100
                      b-form-input.customInput(
                        id="chinese_first_name",
                        type="text",
                        required,
                        trim,
                        :state="validState('chinese_first_name')",
                        v-model="userForm.chinese_first_name",
                        aria-describedby="input-live-help input-name-live-feedback",
                        placeholder="Name"
                      )
                        b-form-invalid-feedback(
                          id="input-name-live-feedback"
                        )
                          span {{ errors[0] }}

              b-form-group
                ValidationProvider(
                  rules="required|mobile",
                  ref="inputValMobile",
                  v-slot="{ errors }"
                )
                  div.customInputDiv
                    span.redRemind.ml-3 *
                    span.white-space-nowrap.ml-2 手機
                    div.w-100
                      b-form-input.customInput(
                        id="mobile",
                        type="text",
                        required,
                        trim,
                        :state="validState('mobile')",
                        v-model="userForm.mobile",
                        aria-describedby="input-live-help input-name-live-feedback",
                        placeholder="09XXXXXXXX"
                      )
                        b-form-invalid-feedback(
                          id="input-name-live-feedback"
                        )
                          span {{ errors[0] }}
                    button.btn.customValidBtn.white-space-nowrap(@click.prevent='countDownHandler()') 驗證

              b-form-group
                ValidationProvider(
                  rules="required",
                  ref="inputValCode",
                  v-slot="{ errors }"
                )
                  div.customInputDiv
                    span.redRemind.ml-3 *
                    span.white-space-nowrap.ml-2 驗證碼
                    div.w-100
                      b-form-input.customInput(
                        id="code",
                        type="text",
                        required,
                        trim,
                        :state="validState('code')",
                        v-model="userForm.code",
                        maxlength="4",
                        aria-describedby="input-live-help input-name-live-feedback",
                        placeholder=""
                      )
                        b-form-invalid-feedback.w-100(
                          id="input-name-live-feedback"
                        )
                          span {{ errors[0] }}

              b-form-group
                ValidationProvider(
                  rules="email",
                  ref="inputValMail",
                  v-slot="{ errors }"
                )
                  div.customInputDiv
                    span.redRemind.ml-4
                    span.white-space-nowrap.ml-2 Email
                    div.w-100
                      b-form-input.customInput(
                        id="email",
                        type="text",
                        required,
                        trim,
                        :state="validState('email')",
                        v-model="userForm.email",
                        aria-describedby="input-live-help input-name-live-feedback",
                        placeholder="請輸入信箱"
                      )
                        b-form-invalid-feedback(
                          id="input-name-live-feedback"
                        )
                          span {{ errors[0] }}

              b-form-group
                ValidationProvider(
                  rules="required",
                  ref="inputValBirthYear",
                  v-slot="{ errors }"
                )
                  div.customInputDiv
                    span.redRemind.ml-3 *
                    span.white-space-nowrap.ml-2 生日
                    div.w-100
                      b-form-select.customInput(
                        id="birthYear",
                        required,
                        v-model="userForm.birthYear",
                        :state="validState('birthYear')",
                        aria-describedby="input-live-help input-name-live-feedback",
                        placeholder="",
                        @change='changeBirthDateOption()'
                      )
                        template(
                          v-slot:first
                        )
                          b-form-select-option.d-none(
                            :value="undefined",
                            disabled
                          ) YYYY
                        b-form-select-option(
                          v-for="(option,index) in birthYearOptions",
                          :key="option.id",
                          :value="option.id"
                        ) {{ option.title }}
                        b-form-invalid-feedback(
                          id="input-name-live-feedback"
                        )
                          span 此欄為必填

              .d-flex
                b-form-group.col-6.pl-0.pr-1
                  ValidationProvider(
                    rules="required",
                    ref="inputValBirthMonth",
                    v-slot="{ errors }"
                  )
                    div.customInputDiv
                      span.redRemind.ml-3 *
                      span.white-space-nowrap.ml-2 生日
                      div.w-100
                        b-form-select.customInput(
                          id="birthYear",
                          required,
                          v-model="userForm.birthMonth",
                          :state="validState('birthMonth')",
                          aria-describedby="input-live-help input-name-live-feedback",
                          placeholder="",
                          @change='changeBirthDateOption()'
                        )
                          template(
                            v-slot:first
                          )
                            b-form-select-option.d-none(
                              :value="undefined",
                              disabled
                            ) MM
                          b-form-select-option(
                            v-for="(option,index) in birthMonthOptions",
                            :key="option.id",
                            :value="option.id"
                          ) {{ option.title }}
                          b-form-invalid-feedback(
                            id="input-name-live-feedback"
                          )
                            span 此欄為必填

                b-form-group.col-6.pl-1.pr-0
                  ValidationProvider(
                    rules="required",
                    ref="inputValBirthDate",
                    v-slot="{ errors }"
                  )
                    div.customInputDiv
                      span.redRemind.ml-3 *
                      span.white-space-nowrap.ml-2 生日
                      div.w-100
                        b-form-select.customInput(
                          id="birthYear",
                          required,
                          v-model="userForm.birthDate",
                          :state="validState('birthDate')",
                          aria-describedby="input-live-help input-name-live-feedback",
                          placeholder="",
                        )
                          template(
                            v-slot:first
                          )
                            b-form-select-option.d-none(
                              :value="undefined",
                              disabled
                            ) DD
                          b-form-select-option(
                            v-for="(option,index) in birthDateOptions",
                            :key="option.id",
                            :value="option.id"
                          ) {{ option.title }}
                          b-form-invalid-feedback(
                            id="input-name-live-feedback"
                          )
                            span 此欄為必填

              b-form-group
                ValidationProvider(
                  rules="required",
                  ref="inputValSex",
                  v-slot="{ errors }"
                )
                  div.customInputDiv
                    span.redRemind.ml-3 *
                    span.white-space-nowrap.ml-2 性別
                    div.w-100
                      b-form-select.customInput(
                        id="sex",
                        required,
                        v-model="userForm.sex",
                        :state="validState('sex')",
                        aria-describedby="input-live-help input-name-live-feedback",
                        placeholder="",
                      )
                        template(
                          v-slot:first
                        )
                          b-form-select-option.d-none(
                            :value="undefined",
                            disabled
                          ) YYYY
                        b-form-select-option(
                          v-for="(sex,index) in sexOptions",
                          :key="sex.id",
                          :value="sex.id"
                        ) {{ sex.name }}
                        b-form-invalid-feedback(
                          id="input-name-live-feedback"
                        )
                          span 此欄為必填
          .px-4.mt-5
            button.button.btn-block.button_clickCustom.button_clickCustom-outline-primary(
              type="button",
              @click="nextStepHandler()"
              style='background-color: #FFF; color: #000'
            )
              | 送出資料

</template>

<script>
import StepComponent from '@/components/step/StepComponent.vue'; // 客製化進度條
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import VerifyComponent from '@/components/verify/VerifyComponent.vue'; // 驗證套件
import { U_M_SIGN_UP_SUCCESS } from '@/router/unbind-member/sign-up';
const moment = require('moment');

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

// 客製化身分證驗證
extend('mobile', {
  validate: (val) => {
    const MobileReg = /^(09)[0-9]{8}$/;
    return MobileReg.test(val);
  },
  message: '行動電話格式錯誤'
});
// 客製化身分證驗證
extend('email', {
  validate: (val) => {
    if (val.trim() === '') return true; // 信箱可以不填
    const EmailReg = /^[^\s]+@[^\s]+\.[^\s]{2,3}$/;
    return EmailReg.test(val);
  },
  message: 'email格式錯誤'
});

export default {
  name: 'SignUpIndex',
  components: {
    StepComponent,
    ValidationProvider,
    ValidationObserver,
    VerifyComponent
  },
  data() {
    return {
      stepArr: [
        { title: '簽署同意書' },
        { title: '輸入個人資料' }
      ],
      nowStep: 1,
      agree_status: false,
      firstType: true, // 第一次進來輸入資料
      userForm: {
        store_id: null,
        register_date: null,
        member_code: null,
        employee_code: null,
        chinese_first_name: null,
        mobile: null,
        code: null,
        email: null,
        birthYear: null,
        birthMonth: null,
        birthDate: null,
        sex: null,
      },
      mobileVerfityCode: null,
      verfityTotalTime: 180,
      verfityNowTime: 0,
      verfityCanClick: true,
      birthYearOptions: [],
      birthMonthOptions: [],
      birthDateOptions: [],
      sexOptions: [
        {
          id: '1', name: '男'
        },
        {
          id: '0', name: '女'
        },
        {
          id: '3', name: '不透露'
        }
      ],
      storeCodeOption: [
        {
          id: 'TD001',
          name: 'TD001'
        },
        {
          id: 'TD002-1',
          name: 'TD002-1'
        },
        {
          id: 'TD003',
          name: 'TD003'
        },
        {
          id: 'TD004',
          name: 'TD004'
        },
        {
          id: 'TD005',
          name: 'TD005'
        },
        {
          id: 'TD006',
          name: 'TD006'
        },
      ]
    };
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    for (let i = 0; i < 100; i++) {
      vm.birthYearOptions.push({
        id: moment().subtract(i, 'year').format('YYYY'),
        title: moment().subtract(i, 'year').format('YYYY')
      });
    }
    for (let i = 1; i <= 12; i++) {
      vm.birthMonthOptions.push({
        id: i,
        title: i
      });
    }

    // 檢查是否能註冊
    // vm.$store.dispatch('member_card/checkCustomSettingHandler', { type: 1})
    //   .then(() => {
    //     vm.$store.commit('toggleLoading', false);
    //   });
    // 檢查綁定狀態
    vm.$store.dispatch('member_sign_up/checkBindingHandler')
      .then(() => {
        vm.$store.dispatch('member_card/checkCustomSettingHandler', { type: 1})
          .then(() => {
            vm.$store.commit('toggleLoading', false);
          });
      });
  },
  methods: {
    nextStepHandler() {
      const vm = this;
      switch (vm.nowStep.toString()) {
      case '1':
        if (!vm.agree_status) {
          this.$swal.fire({
            icon: 'info',
            title: '請勾選同意事項'
          });
        } else {
          vm.nowStep = 2;
        }
        break;
      case '2':
        vm.mobileVerfityHandler();
        break;
      default:
        break;
      }
    },
    // 送出手機驗證
    async mobileVerfityHandler() {
      const vm = this;
      const isValid = await this.$refs.mobileVerfityForm.validate();
      if (!isValid) {
        if (vm.userForm.store_id === null) {
          vm.userForm.store_id = '';
        }
        if (vm.userForm.register_date === null) {
          vm.userForm.register_date = '';
        }
        if (vm.userForm.member_code === null) {
          vm.userForm.member_code = '';
        }
        if (vm.userForm.employee_code === null) {
          vm.userForm.employee_code = '';
        }
        if (vm.userForm.chinese_first_name === null) {
          vm.userForm.chinese_first_name = '';
        }
        if (vm.userForm.mobile === null) {
          vm.userForm.mobile = '';
        }
        if (vm.userForm.email === null) {
          vm.userForm.email = '';
        }
        if (vm.userForm.code === null) {
          vm.userForm.code = '';
        }
        if (vm.userForm.birthYear === null) {
          vm.userForm.birthYear = '';
        }
        if (vm.userForm.birthMonth === null) {
          vm.userForm.birthMonth = '';
        }
        if (vm.userForm.birthDate === null) {
          vm.userForm.birthDate = '';
        }
        if (vm.userForm.sex === null) {
          vm.userForm.sex = '';
        }

        this.$swal.fire({
          icon: 'error',
          title: '請填妥必填欄位或格式輸入錯誤'
        });
      } else {
        // TODO: 驗證驗證碼
        vm.$swal.fire({
          title: '表單送出中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });

        const validateInfo = {
          store_id: vm.userForm.store_id,
          register_date: vm.userForm.register_date,
          member_code: vm.userForm.member_code,
          employee_code: vm.userForm.employee_code,
          chinese_first_name: vm.userForm.chinese_first_name,
          mobile: vm.userForm.mobile,
          email: vm.userForm.email,
          code: vm.userForm.code,
          birthday: vm.userForm.birthYear + vm.userForm.birthMonth + vm.userForm.birthDate,
          sex: vm.userForm.sex,
        };

        // 送出並綁定
        vm.$store.dispatch('unbind_member_sign_up/validateSmsAndRegisterHandler', validateInfo)
          .then((res) => {
            this.$swal.close();
            if (res.data.data) {
              window.location = `${process.env.VUE_APP_SURVEY_FRONTEND_URL}?id=${res.data.data}`;
            } else {
              vm.$router.push({
                name: U_M_SIGN_UP_SUCCESS
              });
            }
          }).catch(() => {

        });
      }
    },
    // 檢查欄位
    validState(key) {
      const vm = this;
      if (vm.userForm[key] !== null) {
        if (key === 'mobile') {
          const MobileReg = /^(09)[0-9]{8}$/;
          return MobileReg.test(vm.userForm[key]);
        }
        if (key === 'email') {
          if (vm.userForm[key].trim() === '') return true; // 信箱可以不填
          const EmailReg = /^[^\s]+@[^\s]+\.[^\s]{2,3}$/;
          return EmailReg.test(vm.userForm[key]);
        }
        return this.userForm[key] ? true : false;
      }
      return null;
    },
    validverfityState() {
      const vm = this;
      if (vm.mobileVerfityCode !== null) {
        return this.mobileVerfityCode ? true : false;
      }
      return null;
    },
    // 倒數驗證碼
    countDownHandler() {
      const vm = this;
      // 發送驗證碼
      vm.$store.dispatch('unbind_member_sign_up/checkExistPosHandler', { mobile: vm.userForm.mobile }).then(() => {
        vm.$store.dispatch('unbind_member_sign_up/sendSmsHandler', vm.userForm.mobile)
          .then(() => {
            vm.$snotify.success(null, '驗證碼已寄出');
            vm.verfityCanClick = false;
            vm.verfityNowTime = vm.verfityTotalTime;
            const clock = window.setInterval(() => {
              if (vm.verfityNowTime === 0) {
                window.clearInterval(clock);
                vm.verfityCanClick = true; // 這裡重新開啟
              } else {
                vm.verfityNowTime -= 1;
              }
            }, 1000);
          });
      });
    },
    changeVerifyCodeHandler() {
      const vm = this;
      vm.$refs.VerifyComponent.changeVerifyCodeHandler();
    },
    changeBirthDateOption() {
      const vm = this;
      vm.userForm.birthDate = null;
      vm.birthDateOptions = [];
      if (vm.userForm.birthYear && vm.userForm.birthMonth) {
        const lastDateOfMonth = moment(`${vm.userForm.birthYear}-${vm.userForm.birthMonth}`, 'YYYY-MM').endOf('month').format('DD');
        for (var i = 1; i <= lastDateOfMonth; i++) {
          vm.birthDateOptions.push({
            id: i,
            title: i
          });
        }
      }
    }

  }
};
</script>

<style lang="scss" scoped>
.customBesideCenter {
  width: 70%;
  position: relative;
  z-index: 10;
}
.customBesideLine {
  height: 0.5rem;
  margin: 0 5px;
  border-top: 1px solid #CCC;
  border-bottom: 1px solid #CCC;
}
.border-bottom {
  border-bottom: 1px solid #CCC;
}
.bg-black {
  background-color: #000;
}
.customContainerBorder {
  border-top-left-radius: 50px;
  background-color: #FFF;
}
.container-width {
  width: 100%;
}
.customInputDiv {
  display: flex;
  align-items: center;
  background: none;
  border: 1px solid #ccc;
  border-radius: 50px;
  padding: 0.3rem 0;
}
.white-space-nowrap {
  white-space: nowrap;
}
  .customInput {
    border: none;
    border-radius: 50px;
  }
  .customValidBtn {
    background-color: #F87FB4;
    color: #FFF;
    padding: 0.1rem 1.5rem;
    margin-right: 1rem;
    border-radius: 50px;
  }
  .customColor {
    color: #F87FB4;
  }
  input:focus {
    border: none;
    box-shadow: none;
  }
</style>

<style>
  .custom-checkbox .custom-control-label::before {
    border-radius: 50%;
  }

  .button_clickCustom {
    background-color: #000;
    color: #FFF;
  }
  .invalid-feedback {
    padding: 0.375rem 0.75rem;
  }
  .custom-select.is-invalid:focus {
    box-shadow: none;
  }
  .custom-select.is-valid:focus {
    box-shadow: none;
  }
  .custom-select:focus {
    box-shadow: none;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-text-fill-color: #495057;
    -webkit-box-shadow: 0 0 0 1000px rgba(255,255,255,0) inset;
    transition: background-color 5000s ease-in-out 0s;
  }
</style>
